import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PaperCurrencyFormatterDirective } from './currency-formatter.directive';
import { PaperCurrencyRoundPipe } from './paper-currency-round.pipe';
import { PaperCurrencyPipe } from './paper-currency.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [PaperCurrencyPipe, PaperCurrencyRoundPipe],
    exports: [PaperCurrencyPipe, PaperCurrencyRoundPipe],
    providers: [PaperCurrencyFormatterDirective],
})
export class PaperCurrencyModule {}
